
import { defineComponent, onMounted, onUnmounted } from "vue";
import { getIllustrationsPath } from "@/core/helpers/assets";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "auth-page-layout",
  components: {},
  setup() {
    let router = useRouter();
    onMounted(() => {
      document.body.classList.add("bg-body");
      const token = window.localStorage.getItem("token");
      const user = window.localStorage.getItem("user");
      if (token && user) {
        router.push({ name: "Dashboard" });
      }
    });

    onUnmounted(() => {
      document.body.classList.remove("bg-body");
    });

    return {
      getIllustrationsPath,
    };
  },
});
